import { handleClick } from './ComponentListItem'

const AdditionalInfo = ({ specificationClick }) => (
  <div
    className="velorbis-customizer-component"
    onClick={(e) => handleClick(e, 'additional-info', specificationClick)}
    data-component="additional-info"
  >
    <div className="velorbis-customizer-component-name">Additional info</div>
    <div className="velorbis-customizer-text-swatch">Off</div>
  </div>
)

export default AdditionalInfo
